import { gql } from '@apollo/client'

export const START_SPEC_INTELLIGENCE_RUN = gql`
    mutation StartSpecIntelligenceRun($input: StartSpecIntelligenceRunInput!) {
        startSpecIntelligenceRun(input: $input) {
            instanceId
        }
    }
`

export const RESOLVE_SPEC_INTELLIGENCE_FINDING = gql`
    mutation ResolveSpecIntelligenceFinding($input: ResolveSpecIntelligenceFindingInput!) {
        resolveSpecIntelligenceFinding(input: $input)
    }
`

export const DISMISS_SPEC_INTELLIGENCE_FINDING = gql`
    mutation DismissSpecIntelligenceFinding($input: DismissSpecIntelligenceFindingInput!) {
        dismissSpecIntelligenceFinding(input: $input)
    }
`
